import { render } from "./shipment-id-select.vue?vue&type=template&id=5728a1cc&scoped=true&ts=true"
import script from "./shipment-id-select.vue?vue&type=script&lang=ts"
export * from "./shipment-id-select.vue?vue&type=script&lang=ts"

import "./shipment-id-select.vue?vue&type=style&index=0&id=5728a1cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5728a1cc"]])

export default __exports__